export default __webpack_public_path__ + "static/media/TimeToRest.280863ba.png";